export default "__VITE_ASSET__A7$kTbIe__"